import "./emailInput.css";
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

function EmailInput({
	emails,
	setEmails,
	style,
	placeholder = "Add participants",
}) {
	const [inputValue, setInputValue] = useState("");

	const handleInputChange = (event) => {
		setInputValue(event.target.value);
	};

	const handleInputKeyPress = (event) => {
		if (event.key === "Enter" || event.key === "," || event.key === " ") {
			event.preventDefault();
			const email = inputValue.trim();
			if (email !== "") {
				if (emails.includes(email)) {
					setInputValue("");
					return;
				}
				if (
					!email.includes("@cardinalstone.com") &&
					!email.includes("@gmail.com")
				) {
					const formattedEmail = email.concat("@cardinalstone.com");
					if (emails.includes(formattedEmail)) {
						setInputValue("");
						return;
					}
					addEmail(formattedEmail);
					setInputValue("");
					return;
				}
				addEmail(email);
				setInputValue("");
			}
		}
	};

	const addEmail = (email) => {
		setEmails((prevEmails) => [...prevEmails, email]);
	};

	const removeEmail = (email) => {
		setEmails((prevEmails) => prevEmails.filter((e) => e !== email));
	};

	return (
		<div
			className={
				style === "default"
					? "text-[#1F2937] text-[13px] font-[400] border border-[#C9C9C9] rounded-[8px] bg-white min-h-[42px] focus:border-[#a3a3a3] outline-none mb-2 py-1 px-2 transition-all duration-300 ease-in-out"
					: "email-input"
			}
		>
			<div
				className={
					style === "default"
						? "flex flex-wrap gap-[15px] items-center p-[5px] min-height-[30px] w-full"
						: "pill-container"
				}
			>
				{emails.map((email) => (
					<div key={email} className="pill">
						<span>{email}</span>
						<FaTimes
							className="pill-close"
							onClick={() => removeEmail(email)}
						/>
					</div>
				))}
				<input
					type="email"
					value={inputValue}
					onChange={handleInputChange}
					onKeyPress={handleInputKeyPress}
					placeholder={placeholder}
					autoComplete="on"
					required={!emails?.length}
					className={
						style === "default"
							? "outline-none border-none px-2 w-full"
							: "email-input-field"
					}
				/>
			</div>
		</div>
	);
}

export default EmailInput;
